import DictpickerControl from './DictpickerControl';

export default DictpickerControl;
